import clsx from 'clsx'

interface DotProps {
  variant?: 'default'
  className?: string
}

export default function Dot({ variant, className }: DotProps) {
  return (
    <div
      className={clsx(
        'w-2 h-2 rounded mr-2 bg-interactive-default',
        variant === 'default' && 'bg-interactive-default',
        className
      )}
    />
  )
}
